import { Budget, BudgetColumn } from "../types";
import BudgetCard from "../budgetCard";
import KanbanEmptyCell from "./KanbanEmptyCell";

interface KanbanColumnsGridProps {
  columns: { key: BudgetColumn; label: string }[];
  budgets: Budget[];
  getBudgetsByColumn: (column: BudgetColumn) => Budget[];
  getBudgetAtRow: (column: BudgetColumn, rowIndex: number) => Budget | null;
  maxRows: number;
  isMobile: boolean;
  isTablet: boolean;
  onViewHistory?: (budgetId: string) => void;
  onAction?: (budgetId: string, action: string) => void;
}

const KanbanColumnsGrid = ({
  columns,
  budgets,
  getBudgetsByColumn,
  getBudgetAtRow,
  maxRows,
  isMobile,
  isTablet,
  onViewHistory,
  onAction,
}: KanbanColumnsGridProps) => {
  if (isMobile) {
    return (
      <div className="flex flex-col gap-4">
        {columns.map((column) => {
          const columnBudgets = getBudgetsByColumn(column.key);
          return (
            <div key={column.key} className="flex flex-col gap-3">
              {columnBudgets.length > 0 ? (
                columnBudgets.map((budget) => (
                  <BudgetCard
                    key={budget.id}
                    budget={budget}
                    onViewHistory={onViewHistory}
                    onAction={onAction}
                  />
                ))
              ) : (
                <KanbanEmptyCell />
              )}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div>
      {Array.from({ length: maxRows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className={`grid ${isTablet ? "grid-cols-3 min-w-[900px]" : "grid-cols-3"} gap-0`}
          style={{ borderBottom: "16px solid #FFFFFF" }}
        >
          {columns.map((column) => {
            const budget = getBudgetAtRow(column.key, rowIndex);
            return (
              <div key={`${column.key}-${rowIndex}`} className="p-0">
                {budget ? (
                  <BudgetCard
                    budget={budget}
                    onViewHistory={onViewHistory}
                    onAction={onAction}
                  />
                ) : (
                  <KanbanEmptyCell />
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default KanbanColumnsGrid;
